/* 離脱popup 
(function () {
  let body           = document.body;
  let popup_overlay  = document.getElementById("popup_overlay");
  let popup  = document.getElementById("popup");
  let close_popup    = document.getElementById("close_popup");
  let cookie         = document.cookie;
  let cookiesArray   = cookie.split(';');
  let cookie_time    = 60;
  let countFlg       = 0;

  history.pushState(null, null, location.href);
  
  window.addEventListener("popstate", function (e) {
    history.go(1);
    //ここでポップアップを呼ぶ
    /*if(window.outerWidth >= 750){
      popup.style.top = `calc(${window.scrollY}px + 20vh)`;
    }
    popup_overlay.style.display = "block";
    body.style.overflow = "hidden";
    
  },{once: true});

  function click(){
    popup_overlay.style.display = "none";
    body.style.overflow = "auto";
  };
  close_popup.addEventListener('click', click);
  popup_overlay.addEventListener('click', click);
})();
*/

/* 時間経過 */

(function() {
  let body           = document.body;
  let popup_overlay  = document.getElementById("popup_overlay");
  let popup  = document.getElementById("popup");
  let close_popup    = document.getElementById("close_popup");
  let cookie         = document.cookie;
  let cookiesArray   = cookie.split(';');
  let cookie_time    = 60;
  let countFlg       = 0;

  for(let c of cookiesArray){
    if( c == ' popupbtnFlg' ){
      countFlg++;
    }
    console.log("countFlg:"+countFlg);
  }

  if(countFlg == 0){
    //3000ミリ(3秒)後にポップアップを表示
    console.log("3秒後に開くよ");
    window.setTimeout(open, 10000);
  } else {
    console.log("1分後に開くよ");
    window.setTimeout(open, cookie_time * 1000);
  }

  function open() {
    popup_overlay.style.display = "block";
    body.style.overflow = "hidden";
  };

  function click() {
    popup_overlay.style.display = "none";
    body.style.overflow = "auto";
    //max-age = <数値>秒 
    //document.cookie=`popupbtnFlg; path=/; max-age=${cookie_time}`;
    document.cookie=`popupbtnFlg; path=/;`;
    //window.setTimeout(open, cookie_time * 1000);
  };
  close_popup.addEventListener('click', click);
  popup_overlay.addEventListener('click', click);
})();